import "./UserWorkspace.css";

import { User, Workspace } from "../../../model/model";
import { useNavigate, useParams } from "react-router-dom";

import React from "react";
import { io } from "socket.io-client";
import { useLoaUser } from "../lessons/lessonHooks";

/**
 * live video chat
 * live presentation
 * live text chat
 *
 * files > quill editor
 * notifications
 */

export default function UserWorkspace() {
  const { loaUser } = useLoaUser();
  const { id: workspaceId } = useParams<{ id: string }>();
  const [workspace, setWorkspace] = React.useState<Workspace | null>(null);
  const [notifications, setNotifications] = React.useState<
    { type: string; content: any }[]
  >([]);
  const socketRef = React.useRef<any>(null);

  React.useEffect(() => {
    if (loaUser) {
      // Create socket connection
      const socket = io();
      socketRef.current = socket;

      socket.on("connect", () => {
        console.log("Socket connected");
        // Join workspace after connection is established
        socket.emit("join-workspace", { workspaceId, userId: loaUser.id });
      });

      socket.on("notification", (data: { type: string; content: any }) => {
        console.log("#-#-#-# Notification received:", data);
        // Add notification to state
        setNotifications((prev) => [...prev, data]);
      });

      socket.on("error", (data: { message: string }) => {
        console.error("Error:", data.message);
        // Handle the error
      });

      socket.connect();

      // Cleanup function to disconnect socket when component unmounts
      return () => {
        console.log("Disconnecting socket");
        socket.disconnect();
        socketRef.current = null;
      };
    }
  }, [loaUser, workspaceId]);

  if (!loaUser) return null;

  console.log("UserWorkspace", { workspaceId, loaUser, notifications });

  return (
    <div className="loa-page user-workspace-page">
      <div className="user-workspace">
        <div className="user-workspace-header">
          <h1>User Workspace</h1>
        </div>
        <div className="user-workspace-content">
          <div className="user-workspace-content-left">
            <h2>Live Video Chat</h2>
            <h2>Live Presentation</h2>
            <h2>Live Text Chat</h2>
          </div>
          <div className="user-workspace-content-right">
            <h2>Files</h2>
            <div className="notifications-panel">
              <h2>Notifications</h2>
              {notifications.length > 0 ? (
                <ul>
                  {notifications.map((notif, index) => (
                    <li key={index}>
                      <strong>{notif.type}:</strong> {notif.content}
                    </li>
                  ))}
                </ul>
              ) : (
                <p>No notifications yet</p>
              )}
              <button
                onClick={() => {
                  socketRef.current?.emit("send-notification", {
                    type: "test",
                    content: "This is a test notification",
                    room: workspaceId,
                    targets: [loaUser.id],
                  });
                }}
              >
                test
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="user-workspace-footer">
        <h2>Footer</h2>
      </div>
      <div className="user-workspace-sidebar">
        <h2>Sidebar</h2>
      </div>
    </div>
  );
}
